var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"height":"medium","width":"large"}},[_c('h2',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t('modals.sidebarList.content.accident_intake')))]),_c('intake-wizard',_vm._g({attrs:{"type":"accident","patientDetails":_vm.patientDetails,"patientId":_vm.patientId,"authenticated":_vm.authenticated}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }